import React, { Component } from "react";
import { CircularProgress } from "@material-ui/core";

export default class BetterCircularProgress extends Component {
    render() {
        return (
            <>
                {this.props.loading ?
                    <div style={{ textAlign: 'center' }}>
                        <div style={this.props.customStyle ?? { marginTop: '25vh', marginBottom: '25vh' }}>
                            <CircularProgress color="inherit" style={{ color: "#147dbf" }} size={50} />
                        </div>
                    </div>
                    : this.props.children
                }
            </>
        );
    }
}